module.exports = __webpack_public_path__ + "src/assets/img/header-dummy-01.jpg";